module.exports = __webpack_public_path__ + "static/media/vue-js.c10d7be2.png";